import React from "react";
import cx from "./cx";

/**
 * Estado vacío: qué falta, qué pasará y el botón que lo resuelve (children).
 *  - icon: nombre de material-icons
 *  - title / body: textos
 */
const RevEmpty = ({ icon, title, body, className, children, ...rest }) => (
    <div className={cx('rev-empty', className)} {...rest}>
        {icon && <span className="rev-empty__icon material-icons" aria-hidden="true">{icon}</span>}
        {title && <span className="rev-empty__title">{title}</span>}
        {body && <span className="rev-empty__body">{body}</span>}
        {children}
    </div>
);

export default RevEmpty;
